/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { useSimpliCity } from "@simplicitycms/simplicity-common";
import { CircularProgress } from "@mui/material";
import { isTrue } from "../utils/empty-exists";

const LayoutWrapperCore = (props) => {

    const children = props.children;

    let { website, webpage, model, seo, loading } = useSimpliCity();

    const site_title = website?.title;
    const domain = website?.domain;
    // const path = webpage?.path;
    const site_domain = `https://${domain}/`;
    const exclude_from_search = webpage?.exclude_from_search ?? false;
    const ogType = "website";
    const twitterCardType = seo?.tw_card_type;
    const title = model?.title;
    const description = model?.description;
    const image = model?.banner_image?.url;
    const url = `${site_domain}${webpage?.path}`;

    const twCardType = seo?.tw_card_type ?? "summary_large_image";

    return (
        <>
            {seo &&
                <Helmet>
                    <link rel="canonical" href={seo?.url} />
                    <meta property="og:url" content={seo?.url} />
                    <meta name="twitter:url" content={seo?.url} />

                    <title>{model?.title}</title>
                    <meta property="og:title" content={model?.title} />
                    <meta name="twitter:title" content={model?.title} />

                    <meta name="description" content={model?.description} />
                    <meta property="og:description" content={model?.description} />
                    <meta name="twitter:description" content={model?.description} />

                    <meta name="og:type" content={seo?.og_type} />
                    <meta name="twitter:card" content={twCardType} />

                    <meta property="og:image" content={image} />
                    <meta name="twitter:image" content={image} />
                    {exclude_from_search &&
                        <meta name="robots" content="noindex" />
                    }
                </Helmet>
            }

            {/* Block Search indexing with noindex */}
            {isTrue(webpage?.exclude_from_search) &&
                <Helmet>
                    <meta name="robots" content="noindex"></meta>
                </Helmet>
            }

            {loading &&
                <div style={{
                    width: "100%",
                    height: "70vh",
                    gap: "24px",
                    display: "flex", flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "40px"
                }}
                >
                    <CircularProgress style={{ color: "#003E43" }} />
                </div>
            }

            {children}

        </>
    );
};

LayoutWrapperCore.displayName = "LayoutWrapperCore";
export { LayoutWrapperCore };
